.link {
    color: var(--mantine-color-gray-6);
}

.footer {
}

.footerText {
    font-size: var(--mantine-font-size-xs);
    color: var(--mantine-color-gneis-6);
    text-align: center;
    margin-top: 2px;
    width: 100%;

    @container (min-width: $mantine-breakpoint-sm) {
        margin-top: var(--mantine-spacing-sm);
    }
}
